
import { HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JwtService, UserService } from '../core';
import { authKey, CatlougeTypeConstants } from "../core/constants";
import { Router } from '@angular/router';

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const jwtService = inject(JwtService);
  const userService = inject(UserService);
  const router = inject(Router);

  // Get existing headers
  const headers = req.headers;
  const existingImgHeader = headers.get('X-Check-Image');
  const userLanguage = localStorage.getItem('userLanguage') || 'en';
  const existingLangCode = headers.get('Lang-code') ?? userLanguage;
  const browserLang = navigator.language; // e.g. en-IN
  const userCountry = browserLang.split('-')[1] || 'IN';

  let headersConfig: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept-Language': existingLangCode,
    'Country': userCountry,
    'Catalogue': CatlougeTypeConstants.catlogue, // '565c8c878c86ba151d29b689',
    'Platform': 'web',
  };

  if (existingImgHeader) {
    delete headersConfig['Content-Type'];
  }

  if (localStorage.getItem('sessionId')) {
    headersConfig['Authorization'] = 'Bearer ' + localStorage.getItem('sessionId');
    headersConfig['profile-id'] = localStorage.getItem('profile_id') || '';
  }

  if (req.url.endsWith('/signupnexg')) {
    headersConfig['Authorization'] = authKey.defaultAuthKey;
  }

  let request = req;
  if (!req.url.includes('phonepe.com')) {
    request = req.clone({ setHeaders: headersConfig });
  }

  return next(request).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // Handle response if needed
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.log('401 Unauthorized detected');
        userService.purgeAuth();
        router.navigate(['/']);
      }
      return throwError(() => error);
    })
  );
};
